/* v-hasPermission 操作权限处理 */

export default {
  inserted(el, binding, vnode) {
    const { value } = binding;

    const allPermission = "*:*:*"; // 所有权限标识

    const permissionList = [allPermission];

    if (value && value instanceof Array && value.length > 0) {
      const permissionFlag = value;

      const hasPermission = permissionList.some((permission) => {
        return (
          allPermission === permission || permissionFlag.includes(permission)
        );
      });

      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    } else {
      throw new Error(`请设置操作权限标签值`);
    }
  },
};
